
<template>
  <div class="app-container">
    <div>
      <p>{{ $t("common.download_template_excel") }}</p>
      <i class="fa fa-download" aria-hidden="true"></i>
      <a href="/static/dataimport/import_liabilities_sample.xlsx" download="import_liabilities_sample">Download</a>
    </div>
    <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload"/>
    <b-table
      striped
      hover
      small
      :items="resultImportList"
      :fields="resultImportList_fields"
      class="mt-3"
      outlined
    >
      <template #head()="scope">
        <div>{{ $t(scope.label) }}</div>
      </template>
      <template slot="statusImport" slot-scope="row">
        <!-- {{row}} -->
        <p style="color:green" v-if="row.item.statusImport == 'PASS'">{{row.item.statusImport}}</p>
        <p style="color:red" v-else>{{row.item.statusImport}}</p>
        <p/>
      </template>
    </b-table>

    <div class="box-footer">
      <button
        id="cmdCancel"
        type="button"
        class="btn btn-labeled btn-danger"
        @click="CancelCustomerList"
        style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
      >
        <span class="btn-label">
          <i class="fa fa-mail-reply"></i>
        </span>
        {{$t('common.back')}}
      </button>
    </div>

    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
import { mapGetters, mapActions } from "vuex";
// import utils from '@/lib/utils'

export default {
  name: "AccountingHomeLiabilityImportExcel",
  components: {
    UploadExcelComponent,
    loading: Loading
  },
  data() {
    return {
      tableData: [],
      tableHeader: [],
      hdBackground: "background-color: #4b646f;border:1px solid white;", //00a65a
      isLoading: false,
      resultImportList: [], // Result import
      resultImportList_fields: [
        {
          key: "apartment_code",
          label: 'apartment.apartment_code',
          sortable: true,
          class: "text-center"
        },
        {
          key: "statusImport",
          label: "common.status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "errorDetail",
          label: "common.error",
          sortable: true,
          class: "text-center"
        }
      ],

      validateElement: {}
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
        "IMPORT_ACCOUNTING_HOME_LIABILITY"
      ]),

    beforeUpload(file) {
      this.isLoading = true
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning"
      });

      this.isLoading = false
      return false;
    },

    handleSuccess({ results, header }) {
      this.tableData = results;

      // console.log(JSON.stringify(this.GET_ACCOUNT_DATA.id))

      let data = {
        headers: header,
        dataImport: results,
        user_created: this.GET_ACCOUNT_DATA.id,
      };
      // init empty
      this.resultImportList = [];
      this.IMPORT_ACCOUNTING_HOME_LIABILITY(data)
        .then(
          function(res) {
            //{"status":"success","dataResult":[{"username":"user11595909","result":"PASS","error":"","type":"UPDATE"}]}

            res.dataResult.forEach(v => {
              let dataPass = {
                apartment_code: v.apartment_code,
                statusImport: v.result,
                errorDetail: v.error
              };
              this.resultImportList.push(dataPass);
            });

            this.isLoading = false
          }.bind(this)
        )
        .catch(
          function() {
            let dataError = {
              username: "Uknow",
              statusImport: "FAIL",
              errorDetail: "Uknow"
            };
            // console.log(JSON.stringify(dataError));
            this.resultImportList.push(dataError);
            this.isLoading = false
          }.bind(this)
        );

      this.tableHeader = header;

      
    },
    CancelCustomerList: function() {
      this.$router.push({
        name: "AccountingHomeLiabilityList"
      });
    }
  },
  mounted() {},
  
};
</script>



// WEBPACK FOOTER //
// src/views/Report/AccountingHomeLiabilityImportExcel.vue